'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var DEFAULT_SAVE_TIMEOUT = exports.DEFAULT_SAVE_TIMEOUT = 5000;

var COMMANDS = exports.COMMANDS = {
    clear: 'clear',
    finishEditing: 'finishEditing',
    onEmptyBackspace: 'onEmptyBackspace'
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/textConstants.js
// module id = 1754
// module chunks = 0